module.exports = __webpack_public_path__ + "img/rsb@2x.8e4b6a91.png";